import { Input } from 'Constants/styles';

import styled from '@emotion/styled';

export const SubTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  margin: 20px 0px 26px;
  color: #6c7488;
`;

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
`;

export const FormWrapper = styled.div`
  font-size: 12px;
  background-color: #fff;
  margin-top: 25px;
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  margin-bottom: 8px;
  display: block;
`;

export const HeavyText = styled.span`
  font-weight: 700;
  color: #000;
`;

export const MultiColRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 15px 0;

  .col {
    flex: 1;
    flex-direction: row;
  }

  .label {
    color: #6c7488;
  }

  label {
    margin-bottom: 0px;
  }
`;

export const FormItem = styled.div`
  padding-bottom: 22px;
  font-weight: 300;
  color: #6c7488;
  position: relative;

  .error-msg {
    margin-left: 5px;
    color: red;
    font-size: 12px;
  }
  .fileUpload {
    display: none;
  }
  .uploadButton {
    display: block;
    margin-top: 30px;
    cursor: pointer;
    font-size: large;
  }
  .pending {
    font-style: italic;
  }
`;

export const Hr = styled.hr`
  height: 1px;
  margin: 40px 0;
  border: 0;
  border-top: 1px solid #e5e5e5;
`;

export const FormControl = styled.select`
  display: block;
  width: 100%;
  height: 40px;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dce3eb;
  border-radius: 2px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-shadow: 0.5px 0.5px 3px 0.6px rgba(220, 227, 235, 0.56);
  margin-bottom: 5px;
`;

export const FileList = styled.ul`
  margin-left: 0;
  list-style: none;
  padding-left: 5px;
  width: 50%;

  li {
    display: flex;
    height: 15px;
    justify-content: space-between;
    :hover {
      .fileAction {
        display: block;
      }
    }
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
  }
  .fileId {
    text-decoration: underline;
    color: #4b4eae;
  }
  .fileAction {
    display: none;
    color: grey;
  }
`;

export const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  button {
    padding: 0 20px;
    margin: 15px;
    background-color: var(--lp-colors-medium-blue-800);
    color: #fff;
    border: 1px solid var(--lp-colors-medium-blue-800);
    border-radius: 4px;
    font-size: 14px;
    line-height: 20px;
    box-shadow: 0.5px 0.5px 3px 0.6px rgb(220 227 235 / 56%);
    width: auto;
    letter-spacing: 0.35px;
    cursor: pointer;
    font-weight: 400;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    height: 40px;
    margin-left: auto;

    &:disabled {
      opacity: 0.5;
    }
  }
`;

export const SaveBtn = styled.button`
  &:focus {
    outline: none;
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const SpinnerWrapper = styled.span`
  display: inline;
  vertical-align: top;
  margin-left: 10px;
`;

interface VInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isValid?: boolean;
}

export const VInput = styled(Input)<VInputProps>`
  border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #dce3eb')};
  margin-bottom: 5px;
  &:focus {
    border: ${({ isValid }) => (isValid === false ? '1px solid red' : '1px solid #505bcc')};
  }
`;

export const ModalFileWrapper = styled.div`
  padding: 20px 0;
  .loading-msg {
    margin: 20px 0;
    color: grey;
  }
  img {
    width: 100%;
  }
`;

export const BusinessProfileHeader = styled.div`
  display: flex;
  display: flex;
  justify-content: space-between;
`;

export const EditBusinessProfile = styled.button`
  color: blue;
  cursor: pointer;
  background: none;
  border: none;
  margin-right: 40px;
`;

export const BusinessProfileDataView = styled.div`
  margin-top: 20px;
`;

export const MessageWrapper = styled.div`
  padding: 60px 0;
  text-align: center;
`;
